<script setup lang="ts">
import type { FactBoxData } from '~/utils/crystallize/pieces'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  data: FactBoxData
}>()

const open = defineModel('open', {
  default: false,
})
</script>

<template>
  <div>
    <section :class="open ? 'max-h-fit after:!bg-none' : 'max-h-[200px]'" class="bg-blurple-100 rounded-4xl p-12 flex flex-col gap-6 overflow-hidden relative transition-all duration-500">
      <h3 class="text-2xl font-bold" v-text="data.title" />

      <ul class="list-disc pl-4 transition-all duration-500" :class="{ '-mt-2': !open }">
        <li v-for="(item, i) in data.facts" :key="item.text ?? i" v-text="item.text" />
      </ul>
    </section>
    <Button class="mx-auto -translate-y-1/2" color="carbon" variant="primary" @click="open = !open">
      {{ open ? 'Skjul' : 'Utvid' }} innhold
      <Icon :icon="faChevronDown" class="transition-transform duration-500" :class="{ 'rotate-180': open }" />
    </Button>
  </div>
</template>

<style scoped>
section::after {
  @apply z-0 content-[''] absolute inset-0 top-auto h-16 pointer-events-none;
  background: linear-gradient(to top, theme('colors.blurple.100') 0 50%, transparent);
}
</style>
